module.exports = __webpack_public_path__ + "static/whirlwind-9fe9c4a220d6cfc2f255567bccbb1b63.jpg";